export default {
  GET_USERS: state => state.users,
  GET_USER: state => state.user,
  GET_ROLES: state => state.roles,
  GET_GROUPS: state => state.groups,
  GET_THEMES: state => state.themes,
  GET_LANGS: state => state.langs,
  GET_USER_PHONES: state => state.user_phones,

  GET_USERS_LIST: state => state.users_list,
}
